'use client'

import { Skeleton } from '@/components/skeleton'
import { RestaurantCardSkeleton } from '@/features/restaurants/restaurant-card/restaurant-card-skeleton'
import { RestaurantCardsProvider } from '@/features/restaurants/restaurant-card/restaurant-cards-context'
import { SEARCH_RESULTS_CLASS_NAME } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-results'

export const CitySkeleton = () => {
    return (
        <div className="flex flex-col ">
            <div className="flex justify-center w-full">
                <Skeleton className="hidden md:block px-4 w-[20%] min-h-[55px] mb-16" />
            </div>

            <div className="md:mt-10" />

            <Skeleton className="opacity-50 md:opacity-100 px-4 w-full min-h-8 md:min-h-[48px]" />

            <div className="mt-6 md:mt-[104px]" />

            <div className="w-full flex flex-col pb-14">
                <div className={SEARCH_RESULTS_CLASS_NAME}>
                    <RestaurantCardsProvider styleType="default">
                        <RestaurantCardSkeleton />
                        <RestaurantCardSkeleton />
                        <RestaurantCardSkeleton />
                        <RestaurantCardSkeleton />
                        <RestaurantCardSkeleton />
                        <RestaurantCardSkeleton />
                    </RestaurantCardsProvider>
                </div>
            </div>
        </div>
    )
}
